// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import MapsGeolocation from "./MapsGeolocation.js";

export * from "./generated/index.js";
export default MapsGeolocation;
